export default "__VITE_ASSET__31WasFqwQ8l0hCAsPLLhsA__"